import { toast } from "react-toastify";
import Loader from "src/components/common/Loader/Loader";
import { usePutBusSimulateQuery } from "src/services/react-query-apis/put-bus-simulate";
import { usePutBusMutation } from "src/services/react-query-apis/put-bus";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DataChanges from "src/components/common/update-confirmation/data-changes";
import BusScheduleAffectedAttendances from "./bus-schedule-affected-attendances";
import moment from "moment";
import { getCurrentMonth } from "src/services/auth/token";

const BusesUpdateConfirm = ({ updatePayload, onClose, onBack }) => {
  const putBusSimulateQuery = usePutBusSimulateQuery({
    ...updatePayload,
    queryConfig: {
      staleTime: 0,
    },
  });

  const mutationConfig = {
    onSuccess: async data => {
      toast.success(data.message);
      onClose();
    },
  };

  const putBusMutation = usePutBusMutation({
    mutationConfig,
  });

  if (putBusSimulateQuery.isFetching) {
    return <Loader message="データを取得中..." />;
  }

  if (putBusSimulateQuery.isError) {
    return (
      <>
        <div className="text-danger text-center mb-3 p-1 rounded bg-light border fw-bold">
          {putBusSimulateQuery.error.response.data.message}
        </div>
        <div className="text-end">
          <button className="btn btn-primary" onClick={onBack}>
            戻る
          </button>
        </div>
      </>
    );
  }

  const { affected_bus_schedules, changes, can_update } =
    putBusSimulateQuery.data.data;
  const hasAffectedBusSchedules = affected_bus_schedules.length > 0;

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex flex-column w-100">
        <div>
          <div
            className="alert alert-warning mb-3 text-center p-1"
            role="alert"
          >
            <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
            この変更は{" "}
            {moment(getCurrentMonth())
              .add(1, "month")
              .format("YYYY年MM月")}{" "}
            から適用されます
          </div>
          <div className="mb-4">
            <h6 className="text-center mb-3">バス変更の確認</h6>
            <div className="d-flex flex-column gap-3">
              <DataChanges changes={changes} />
            </div>
          </div>

          {hasAffectedBusSchedules && (
            <div className="mb-3">
              <h6 className="text-center mb-3">
                影響を受けるバススケジュールと出席予定
              </h6>
              {affected_bus_schedules.map(affectedBusScheduleInfo => {
                const oldDescription =
                  affectedBusScheduleInfo.old_bus_schedule?.description;
                const newDescription =
                  affectedBusScheduleInfo.new_bus_schedule?.description;

                return (
                  <div className="mb-4" key={affectedBusScheduleInfo.id}>
                    <div className="alert alert-secondary mb-2 p-2 text-center">
                      <strong>
                        {oldDescription}
                        {oldDescription !== newDescription &&
                          " → " + newDescription}
                      </strong>
                    </div>
                    <BusScheduleAffectedAttendances
                      key={affectedBusScheduleInfo.id}
                      affectedAttendances={
                        affectedBusScheduleInfo.affected_attendances
                      }
                    />
                  </div>
                );
              })}
            </div>
          )}
          {!can_update && (
            <div className="alert alert-warning text-center mb-3" role="alert">
              <FontAwesomeIcon icon="exclamation-triangle" className="me-2" />
              エラーを修正してから再度お試しください
            </div>
          )}
          <div className="d-flex gap-2 justify-content-end mt-3">
            <button className="btn btn-secondary px-4" onClick={onBack}>
              戻る
            </button>
            <button
              className="btn btn-primary px-4"
              onClick={() => {
                putBusMutation.mutate(updatePayload);
              }}
              disabled={putBusMutation.isPending || !can_update}
            >
              {putBusMutation.isPending ? "処理中..." : "更新"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusesUpdateConfirm;
